import { render, staticRenderFns } from "./CustomerAddressSelect.vue?vue&type=template&id=36f3fb2e&"
import script from "./CustomerAddressSelect.vue?vue&type=script&lang=js&"
export * from "./CustomerAddressSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports